export const LOGIN_PAGE = 'login.index'
export const REGISTRATION = 'registration.index'
export const PERMISSIONS_ERROR = 'permissions_error.index'
export const MOBILE_UNSUPPORTED = 'mobile.unsupported'
export const PRIVACY = 'info.privacy'
export const TERMS = 'info.terms'
export const PROFORMA_INVOICE = 'info.proforma_invoice'

export const PARCEL_REQUIREMENTS = 'info.parcel_requirements'

// Staff router names
export const STAFF_PAGE = 'staff.index'
export const STAFF_CUSTOMERS_LIST = 'staff.customers.list'
export const STAFF_CUSTOMERS_CREATE = 'staff.customers.create'
export const STAFF_CUSTOMERS_PRICES = 'staff.customers.prices'
export const STAFF_ASSIGNMENTS_LIST = 'staff.assignments.list'
export const STAFF_ASSIGNMENTS_CREATE = 'staff.assignments.create'
export const STAFF_ASSIGNMENTS_DETAILS = 'staff.assignments.details'
export const STAFF_ASSIGNMENTS_SINGLE_EDIT = 'staff.assignments.edit'
export const STAFF_ASSIGNMENT_PRICES = 'staff.assignments.prices'
export const STAFF_BASE_PRICE_PAGE = 'staff.base.price'
export const STAFF_ASSIGNMENTS_OPTIMIZATION_REPORT = 'staff.assignments.optimization.report'
export const STAFF_SHIPMENTS = 'staff.shipments'
export const STAFF_HOME_PAGE = STAFF_SHIPMENTS

export const STAFF_STATISTICS = 'staff.statistics.index'
export const STAFF_SENDER_ADDRESS_PRICES = 'staff.senderAddress.prices.index'
export const STAFF_PICKUPS_LIST = 'customer.pickups.index'
export const STAFF_REPORTS = 'staff.reports.index'
export const STAFF_AGREEMENT_COMPARE = 'staff.agreement.compare'
export const STAFF_INVENTORY = 'staff.inventory.index'
export const STAFF_INVENTORY_CUSTOMER = 'staff.inventory.customer'
export const STAFF_INVENTORY_REDIRECT = 'staff.inventory.redirect'
export const STAFF_INVENTORY_PRODUCTS = 'staff.inventory.products'
export const STAFF_INVENTORY_INBOUND_RECEIPTS = 'staff.inventory.inboundReceipts'
export const STAFF_INVENTORY_TRANSACTIONS = 'staff.inventory.transactions'
export const STAFF_USERS_LIST = 'staff.users.list'
export const STAFF_ADDRESS_BOOK = 'staff.address-book.index'
export const STAFF_ADDRESS_BOOK_COMPANY = 'staff.address-book.company'
export const STAFF_AUDIT_LOGS = 'staff.auditLogs.index'

// Customer router names
export const CUSTOMER_PAGE = 'customer.index'
export const CUSTOMER_FORGOT_PASSWORD = 'customer.forgotPass.index'
export const CUSTOMER_CREATE_PASSWORD = 'customer.createPass.index'
export const CUSTOMER_RESET_PASSWORD = 'customer.resetPass.index'
export const CUSTOMER_ASSIGNMENTS_LIST = 'customer.assignments.list'
export const CUSTOMER_ASSIGNMENTS_CREATE = 'customer.assignments.create'
export const CUSTOMER_ASSIGNMENTS_DETAILS = 'customer.assignments.details'
export const CUSTOMER_ASSIGNMENTS_SINGLE_EDIT = 'customer.assignments.edit'
export const CUSTOMER_ASSIGNMENTS_OPTIMIZATION_REPORT = 'customer.assignments.optimization.report'
export const CUSTOMER_STATISTICS = 'customer.statistics.index'

export const CUSTOMER_SHIPMENTS = 'customer.shipments'
export const CUSTOMER_HOME_PAGE = CUSTOMER_SHIPMENTS
export const CUSTOMER_PROFILE = 'customer.profile.index'
export const CUSTOMER_PROFILE_SUCCESS = 'customer.profile.success'
export const CUSTOMER_REPORTS = 'customer.reports.index'
export const CUSTOMER_ADDRESS_BOOK = 'customer.address-book.index'

export const FAQ_PAGE = 'faq.index'
export const FAQ_LIST = 'faq.list'
export const FAQ_CREATE = 'faq.create'
export const FAQ_EDIT = 'faq.edit'

export const INFO_PAGE = 'info'
export const SCAN_PAGE = 'scan.index'
export const DOWNLOAD_PAGE = 'download.index'

export const PROXY_MESSAGES = 'proxy.messages.index'
export const CARRIER_MESSAGES = 'carrier.messages.index'
export const FORWARDING_HUB = 'forwarding.index'

// Guides router names
export const PROFORMA_INVOICE_GUIDE = 'guides.proformaInvoice.index'

export const STAFF_PUMPING_PROTECTION = 'staff.pumping-protection'
export const STAFF_MESSAGING_PROTECTION = 'staff.deployment-protection'
